import React from 'react';

export class Auth extends React.Component {
  render() {
    return (
      <li>
        <span>
          Auth: Token based service to service communication was established using Keycloak. [ Code Contribution: 30% which includes setting up all service to service authorizations through keycloak, for connvex ]
        </span>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Auth.js